var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "page_Container" } }, [
    _c(
      "div",
      { staticClass: "page" },
      [
        _c(
          "div",
          {
            staticClass: "main-container orderbody",
            attrs: { id: "main-container" }
          },
          [
            _c("div", { staticClass: "addrinfo toastClass" }, [
              _vm.requireInfo.defaultAddressFlag === "2" ||
              _vm.requireInfo.flag === "2"
                ? _c(
                    "div",
                    {
                      staticClass: "addr adddetail",
                      on: {
                        click: function($event) {
                          _vm.gochoose()
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "consignee" }, [
                        _c("span", { staticClass: "name" }, [
                          _vm._v(
                            _vm._s(_vm.requireInfo.defaultAddress.receiver)
                          )
                        ]),
                        _c("span", { staticClass: "phone" }, [
                          _vm._v(
                            _vm._s(_vm.requireInfo.defaultAddress.mobileNumber)
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "address" }, [
                        _c("img", {
                          attrs: {
                            src: require("../assets/img/goods/addr.png"),
                            alt: ""
                          }
                        }),
                        _c("span", { staticClass: "addrdetail" }, [
                          _vm._v(
                            _vm._s(_vm.requireInfo.defaultAddress.area) +
                              _vm._s(_vm.requireInfo.defaultAddress.address)
                          )
                        ])
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.requireInfo.defaultAddressFlag === "1"
                ? _c(
                    "div",
                    {
                      staticClass: "addr",
                      on: {
                        click: function($event) {
                          _vm.gochoose()
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("../assets/img/goods/addr.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "noaddr choose" }, [
                        _vm._v("选择收货地址")
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.requireInfo.defaultAddressFlag === "0"
                ? _c(
                    "div",
                    {
                      staticClass: "addr",
                      on: {
                        click: function($event) {
                          _vm.goadd()
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("../assets/img/goods/addr.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "noaddr add" }, [
                        _vm._v("新增收货地址")
                      ])
                    ]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _vm._l(_vm.orderRespDTOList, function(item, index) {
              return _c(
                "div",
                { key: index, staticClass: "productStyle" },
                [
                  _c("p", { staticClass: "title" }, [
                    item.label === "自营"
                      ? _c("img", { attrs: { src: _vm.zt, alt: "" } })
                      : _c("img", { attrs: { src: _vm.kd, alt: "" } }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(item.label))])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "ordergoods" },
                    _vm._l(item.value.memberOrderItemList, function(good) {
                      return _c("div", { key: good.id, staticClass: "goods" }, [
                        _c("div", { staticClass: "goods-img" }, [
                          _c("img", {
                            attrs: { src: good.productImg, alt: "" }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "goods-detail" }, [
                          _c("p", { staticClass: "goodstitle" }, [
                            _vm._v(_vm._s(good.productName))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "specifications" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(good.specificationValue) +
                                "\n                            "
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "goodsprice" }, [
                            _vm._v("\n                                ¥"),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.ESVBase.numberTofixed(good.productPrice)
                                )
                              )
                            ]),
                            _c("span", { staticClass: "num" }, [
                              _vm._v("×" + _vm._s(good.quantity))
                            ])
                          ])
                        ])
                      ])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "van-cell-group",
                    { attrs: { border: false } },
                    [
                      _c("van-cell", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: item.value.pickupShow,
                            expression: "item.value.pickupShow"
                          }
                        ],
                        attrs: {
                          title: "是否自提",
                          value: item.value.isPickupStr,
                          border: false,
                          "value-class": "spanStyleRight",
                          "is-link": ""
                        },
                        on: {
                          click: function($event) {
                            _vm.pickupClick(item, index)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("van-cell", {
                        attrs: {
                          title: "配送方式",
                          value: item.value.deliveryMethodStr,
                          border: false,
                          "value-class": "spanStyleRight"
                        }
                      }),
                      _vm._v(" "),
                      !_vm.showReferralFeature
                        ? _c("van-cell", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: item.value.outletShow,
                                expression: "item.value.outletShow"
                              }
                            ],
                            attrs: {
                              title: "选择网点",
                              value: item.value.outletName,
                              border: false,
                              "value-class": "spanStyleRight",
                              "is-link": ""
                            },
                            on: {
                              click: function($event) {
                                _vm.choiceDot(item, index)
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("van-cell", {
                        attrs: {
                          title: "物流运费",
                          value: "¥" + item.value.freightAmount.toFixed(2),
                          border: false,
                          "value-class": "spanStyleRight"
                        }
                      }),
                      _vm._v(" "),
                      _c("van-cell", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.genericCouponShow,
                            expression: "genericCouponShow"
                          }
                        ],
                        attrs: {
                          title: "套装优惠",
                          value:
                            "- ¥" + item.value.groupBenefitAmount.toFixed(2),
                          border: false,
                          "value-class": "spanStyleRight"
                        }
                      }),
                      _vm._v(" "),
                      item.value.activityId !== "-1"
                        ? _c("van-cell", {
                            attrs: {
                              title: "活动优惠",
                              value: _vm.getActivity(item.value),
                              border: false,
                              "value-class": "spanStyleRight"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("van-field", {
                        attrs: {
                          label: "订单备注：",
                          type: "textarea",
                          placeholder: "选填：填写内容已和卖家协商确认",
                          rows: "1",
                          autosize: "",
                          "input-align": "right"
                        },
                        on: {
                          focus: function($event) {
                            _vm.msgfocus()
                          },
                          blur: function($event) {
                            _vm.msgblur()
                          }
                        },
                        model: {
                          value: item.value.remark,
                          callback: function($$v) {
                            _vm.$set(item.value, "remark", $$v)
                          },
                          expression: "item.value.remark"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  item.value.activeList && item.value.activeList.length > 0
                    ? _c("div", { staticClass: "require distribution" }, [
                        _c(
                          "div",
                          [
                            _c(
                              "van-popup",
                              {
                                attrs: { position: "bottom", overlay: true },
                                model: {
                                  value: _vm.fullshow,
                                  callback: function($$v) {
                                    _vm.fullshow = $$v
                                  },
                                  expression: "fullshow"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "attrsNew" },
                                  [
                                    _c(
                                      "van-radio-group",
                                      {
                                        model: {
                                          value: _vm.fullIdNew,
                                          callback: function($$v) {
                                            _vm.fullIdNew = $$v
                                          },
                                          expression: "fullIdNew"
                                        }
                                      },
                                      [
                                        _c(
                                          "van-cell-group",
                                          _vm._l(_vm.activeList, function(
                                            active
                                          ) {
                                            return _c(
                                              "div",
                                              { key: active.activityId },
                                              [
                                                active.activityType === 2
                                                  ? _c(
                                                      "van-cell",
                                                      {
                                                        attrs: {
                                                          title:
                                                            "满" +
                                                            active.meet +
                                                            "件减" +
                                                            active.preferentialAmount +
                                                            "元",
                                                          clickable: ""
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.clickRadio(
                                                              active,
                                                              item,
                                                              active.aindex
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("div", {
                                                          staticClass:
                                                            "divRight"
                                                        }),
                                                        _vm._v(" "),
                                                        _c("van-radio", {
                                                          attrs: {
                                                            name:
                                                              active.activityId
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                active.activityType === 3
                                                  ? _c(
                                                      "van-cell",
                                                      {
                                                        attrs: {
                                                          title:
                                                            "满" +
                                                            active.meet +
                                                            "件打" +
                                                            Number(
                                                              active.preferentialAmount
                                                            ) /
                                                              10 +
                                                            "折",
                                                          clickable: ""
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.clickRadio(
                                                              active,
                                                              item,
                                                              active.aindex
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("div", {
                                                          staticClass:
                                                            "divRight"
                                                        }),
                                                        _vm._v(" "),
                                                        _c("van-radio", {
                                                          attrs: {
                                                            name:
                                                              active.activityId
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                active.activityType === 4
                                                  ? _c(
                                                      "van-cell",
                                                      {
                                                        attrs: {
                                                          title:
                                                            active.activityTitle,
                                                          clickable: ""
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.clickRadio(
                                                              active,
                                                              item,
                                                              active.aindex
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("div", {
                                                          staticClass:
                                                            "divRight"
                                                        }),
                                                        _vm._v(" "),
                                                        _c("van-radio", {
                                                          attrs: {
                                                            name:
                                                              active.activityId
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          }),
                                          0
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "clickoff",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        _vm.closeFullShow()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                关闭\n                            "
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "js" }, [
                    _vm._v(
                      "\n                    共" +
                        _vm._s(item.value.quantity) +
                        "件，小计："
                    ),
                    _c("span", [
                      _vm._v("¥" + _vm._s(item.value.orderPayAmount.toFixed(2)))
                    ])
                  ])
                ],
                1
              )
            }),
            _vm._v(" "),
            _vm.showReferralFeature
              ? _c(
                  "div",
                  { staticClass: "productStyle" },
                  [
                    _c("van-cell", {
                      attrs: {
                        title: "选择门店",
                        value: _vm.referralOutlet,
                        border: false,
                        "value-class": "spanStyleRight",
                        "is-link": ""
                      },
                      on: { click: _vm.choiceReferralOutlet }
                    }),
                    _vm._v(" "),
                    _c(
                      "van-cell-group",
                      { attrs: { border: false } },
                      [
                        _c("van-field", {
                          attrs: {
                            label: "推荐码：",
                            type: "textarea",
                            placeholder: "请输入推荐码",
                            rows: "1",
                            autosize: "",
                            "input-align": "right"
                          },
                          model: {
                            value: _vm.referralCode,
                            callback: function($$v) {
                              _vm.referralCode = $$v
                            },
                            expression: "referralCode"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.requireInfoall.couponList &&
            _vm.requireInfoall.couponList.length >= 1
              ? _c(
                  "div",
                  {
                    staticClass: "require distribution",
                    on: {
                      click: function($event) {
                        _vm.showActivity()
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "choose" }, [
                      _c("span", { staticClass: "yhStyle" }, [
                        _vm._v("优惠券")
                      ]),
                      _c("span", { staticClass: "f-right" }, [
                        _vm._v(_vm._s(_vm.couponSimpleName || _vm.couponName))
                      ])
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "van-cell-group",
                  [
                    _c("van-cell", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.requireInfoall.genericCouponList &&
                            _vm.requireInfoall.genericCouponList.length > 1,
                          expression:
                            "\n                            requireInfoall.genericCouponList &&\n                            requireInfoall.genericCouponList.length > 1\n                        "
                        }
                      ],
                      attrs: {
                        title: _vm.genericCoupon,
                        "is-link": "",
                        "arrow-direction": "down"
                      },
                      on: {
                        click: function($event) {
                          _vm.showGenericCouponPicker = true
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.requireInfoall.usePoint > 0
                      ? _c(
                          "van-cell",
                          {
                            staticClass: "checkBox",
                            attrs: { title: "" },
                            on: { click: _vm.cellClickCheck }
                          },
                          [
                            _c("template", { slot: "title" }, [
                              _c("span", { staticClass: "custom-title" }, [
                                _vm._v(
                                  "可用" +
                                    _vm._s(_vm.requireInfoall.usePoint) +
                                    "积分抵扣" +
                                    _vm._s(
                                      _vm.requireInfoall.allDeductionAmount
                                    ) +
                                    "元"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("van-checkbox", {
                              staticClass: "checkBoxStyle",
                              on: { change: _vm.changeChecked },
                              model: {
                                value: _vm.checked,
                                callback: function($$v) {
                                  _vm.checked = $$v
                                },
                                expression: "checked"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "checkBoxDiv" })
                          ],
                          2
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "require distribution" },
              [
                _c(
                  "van-popup",
                  {
                    attrs: { position: "bottom", overlay: true },
                    model: {
                      value: _vm.showstyleActivity,
                      callback: function($$v) {
                        _vm.showstyleActivity = $$v
                      },
                      expression: "showstyleActivity"
                    }
                  },
                  [
                    _c("div", { staticClass: "paratitle" }, [
                      _vm._v("优惠详情")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "attrs" },
                      [
                        _c(
                          "van-radio-group",
                          {
                            model: {
                              value: _vm.radioActivity,
                              callback: function($$v) {
                                _vm.radioActivity = $$v
                              },
                              expression: "radioActivity"
                            }
                          },
                          [
                            _c(
                              "van-cell-group",
                              _vm._l(_vm.requireInfoall.couponList, function(
                                item
                              ) {
                                return _c(
                                  "van-cell",
                                  {
                                    key: item.id,
                                    attrs: {
                                      title:
                                        item.couponSimpleName ||
                                        item.couponName,
                                      clickable: "",
                                      label: item.couponValidityStart
                                        ? item.couponValidityStart +
                                          "-" +
                                          item.couponValidityEnd
                                        : ""
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.activityClick(item)
                                      }
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "divRight" }),
                                    _vm._v(" "),
                                    _c("van-radio", {
                                      attrs: { name: item.couponCode }
                                    })
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "clickoff",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            _vm.clickoffbtnActivity()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        确定\n                    "
                        )
                      ]
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "placehholder" })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.submitShow,
                expression: "submitShow"
              }
            ],
            staticClass: "bottomtab"
          },
          [
            _c("op-submit-bar", {
              attrs: {
                num: _vm.allTotalNum,
                price:
                  _vm.requireInfoall.sumPayAmount >= 0
                    ? _vm.requireInfoall.sumPayAmount
                    : 0,
                "button-text": "提交订单"
              },
              on: {
                submit: function($event) {
                  _vm.onSubmit()
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "van-popup",
          {
            attrs: { position: "bottom" },
            model: {
              value: _vm.showGenericCouponPicker,
              callback: function($$v) {
                _vm.showGenericCouponPicker = $$v
              },
              expression: "showGenericCouponPicker"
            }
          },
          [
            _c("van-picker", {
              attrs: {
                "show-toolbar": "",
                columns: _vm.requireInfoall.genericCouponList,
                "default-index": 0,
                "value-key": "couponShowName"
              },
              on: {
                confirm: _vm.genericCouponConfirm,
                cancel: function($event) {
                  _vm.showGenericCouponPicker = false
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "van-popup",
          {
            attrs: { position: "bottom" },
            model: {
              value: _vm.showPickupPicker,
              callback: function($$v) {
                _vm.showPickupPicker = $$v
              },
              expression: "showPickupPicker"
            }
          },
          [
            _c("van-picker", {
              ref: "pickupPicker",
              attrs: {
                "show-toolbar": "",
                columns: ["是", "否"],
                "default-index": _vm.pickupDefaultIndex
              },
              on: {
                confirm: _vm.pickupConfirm,
                cancel: function($event) {
                  _vm.showPickupPicker = false
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "van-popup",
          {
            attrs: { position: "bottom" },
            model: {
              value: _vm.showCOPicker,
              callback: function($$v) {
                _vm.showCOPicker = $$v
              },
              expression: "showCOPicker"
            }
          },
          [
            _c("van-picker", {
              attrs: {
                "show-toolbar": "",
                columns: _vm.outletList,
                "default-index": _vm.referralOutletDefaultIndex,
                "value-key": "outletName"
              },
              on: {
                confirm: _vm.setReferralOutlet,
                cancel: function($event) {
                  _vm.showCOPicker = false
                }
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "afteraddrpng" }, [
      _c("img", {
        attrs: { src: require("../assets/img/goods/afteraddr.png"), alt: "" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }